import moment from 'moment/src/moment';
import * as RouterUtils from '@/libs/routerutils';
import config from 'libs/config';
import logger from '@/plugins/logger';
import sanitizer from '@/plugins/sanitizer';
import urljoin from 'url-join';
import { i18n } from '@/localize';

export default class Utils {
  static getColumnStringValue (entry, column) {
    if (entry == null || entry[column.FieldName] == null) {
      return null;
    }

    var entryString = entry[column.FieldName];

    if (this.isDateTimeColumn(column)) { // DateTime
      let date = moment(entryString);
      let format = this.getDateFormat();
      let timeformat = this.getTimeFormat();
      let timewithsecondsformat = this.getTimeWithSecondsFormat();

      if (column.ColumnFormat === 3) {
        // ShortTime
        entryString = `${date.format(timeformat)}`;
      } else if (column.ColumnFormat === 5) {
        // ShortDate
        entryString = date.format(format);
      } else if (column.ColumnFormat === 9) {
        // ShortDateShortTime
        entryString = `${date.format(format)} ${date.format(timeformat)}`;
      } else if (column.ColumnFormat === 10) {
      // ShortDateShortTimeWithSeconds
      entryString = `${date.format(format)} ${date.format(timewithsecondsformat)}`;
      } 
    }
    else if (column.FieldType === 2) { // boolean
      let trueval = entryString;
      entryString = `<input type="checkbox" ${trueval ? 'checked' : ''} disabled />`;
    } else if (column.ComputedFieldDictionaryType === 1) {
       
      // object state
      var state = entry[column.ComputedFieldName];
      entryString =
            '<span class="' + state.CssClass + '">' + entryString + '</span>';
    }
    else  if (column.ComputedFieldDictionaryType === 3) {
          // Enum or PreProcessed
      entryString = entry[column.FieldName + '_ToString'];
    }
    
    //Sanitize
    if (this.isHTMLColumn(column))
      entryString = sanitizer.sanitize(entryString);
    
    return entryString;
  }

  static formatColumn (entry, column) {
    let stringValue = this.getColumnStringValue(entry, column);

    if (stringValue == null) {
      return ''; // returns an empty value for in the grid div
    } else {
      return stringValue;
    }
  }

  /**
   * Check if colum search is disabled
   * @static
   * @param {*} column
   * @returns { Boolean }
   * @memberof Utils
   */
  static isColumnSearchDisabled(column) {
    // right click without column
    if (!column) return true;
    
    // new screen enums can be filtered
    if (column.hasOwnProperty('DisableSearch')){
      if (column.ComputedFieldDictionaryType != null && column.ComputedFieldDictionaryType > 0 && column.ComputedFieldDictionaryType !== 3) return true;
    }
    else{
      // old screen enums cannot be filtered
      if (column.ComputedFieldDictionaryType != null && column.ComputedFieldDictionaryType > 0) return true;
    }
      
    if (column.DisableSearch) return true;
    return false;
  }
  static isHTMLColumn(column) {
    //Checkbox or Computedcolumns 
    //HasAction columns
    return (column.HasAction  || column.FieldType === 2 || (column.ComputedFieldDictionaryType != null && ( column.ComputedFieldDictionaryType === 1 || column.ComputedFieldDictionaryType === 2)));
  }
  static arrayMove (arr, oldIndex, newIndex) {
    if (newIndex >= arr.length) {
      var k = newIndex - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
    return arr; // for testing
  }

  static isValidDate (d) {
    return d instanceof Date && !isNaN(d);
  }

  static isDateTimeColumn (column) {
    return (column.FieldType === 4 || column.FieldType === 19 || column.FieldType === 31 || column.FieldType === 33);
  }

  static isTimeFormat (column) {
    return ((column.FieldType === 4 || column.FieldType === 19 || column.FieldType === 31 || column.FieldType === 33) && (column.ColumnFormat === 3));
  }

  static jsonToDate (jsonDateString) {
    let iso = new Date(jsonDateString);
    if (this.isValidDate(iso)) return iso;
    return new Date(parseInt(jsonDateString.replace('/Date(', '')));
  }

  static jsonToTime (jsonDateString) {
    let date = moment(jsonDateString);
    return date.format(this.getTimeFormat());
  }

  static getTimeFormat () {
    let timeformat = 'HH:mm';
    return timeformat;
  }
  static getTimeWithSecondsFormat () {
    let timewithsecondsformat = 'HH:mm:ss';
    return timewithsecondsformat;
  }
  static getDateFormat () {
    const format = window.curDateFormatMJS? window.curDateFormatMJS : 'D-M-YYYY';
    return format;
  }

  static isElementInViewport (el, box) {
    let rect = el.getBoundingClientRect();
    let boxrect = box.getBoundingClientRect();

    logger.log('rect bottom', rect.bottom);
    logger.log('boxrect bottom', boxrect.bottom);

    return (rect.top >= 0 && (rect.bottom - 1) <= boxrect.bottom);
  }
  static sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  static utcToLocal(datetime) {
    let date = moment.utc(datetime).local();
    let format = this.getDateFormat();
    let timewithsecondsformat = this.getTimeWithSecondsFormat();
    return `${date.format(format)} ${date.format(timewithsecondsformat)}`;
  }

  static dateToString(datetime) {
    if (!datetime) return '';
    let date = moment(datetime);
    let format = this.getDateFormat();
    return `${date.format(format)}`;
  }

  // returns date time with default date format with hourformat with seconds
  static dateTimeToString(datetime) {
    if (!datetime) return '';
    let date = moment(datetime);
    let format = this.getDateFormat();
    let timewithsecondsformat = this.getTimeWithSecondsFormat();
    return `${date.format(format)} ${date.format(timewithsecondsformat)}`;
  }

  // returns date time with default date format with hourformat without seconds
  static dateTimeToStringShort(datetime) {
    if (!datetime) return '';
    let date = moment(datetime);
    let format = this.getDateFormat();
    let timeformat = this.getTimeFormat();
    return `${date.format(format)} ${date.format(timeformat)}`;
  }

  static nameOfMonth(datetime) {
    if (!datetime) return '';
    let date = moment(datetime);
    // return '';
    return `${date.format('MMMM')}`;
  }

  static RedirectToLogin(msg) {
    this.ShowRedirectToLogin(msg);
  }

  static ShowRedirectToLogin(msg) {
    let translation;
    if (i18n && i18n.t) {
      translation = i18n.t('relogin_dialog.msg');
    } 
    
    let translatedMessage = msg || translation || 'U bent automatisch uitgelogd omdat uw sessie is verlopen. Klik hier om opnieuw in te loggen of ga naar de homepagina.'; // last fallback

    // Prevent multiple overlays
    if (document.getElementById('autologout-overlay')) return;

    // Create overlay
    const overlay = document.createElement('div');
    overlay.id = 'autologout-overlay';
    overlay.style.position = 'fixed';
    overlay.style.top = 0;
    overlay.style.left = 0;
    overlay.style.width = '100vw';
    overlay.style.height = '100vh';
    overlay.style.background = 'rgba(0,0,0,0.6)';
    overlay.style.backdropFilter = 'blur(6px)';
    overlay.style.display = 'flex';
    overlay.style.alignItems = 'center';
    overlay.style.justifyContent = 'center';
    overlay.style.zIndex = 9999;

    // Create dialog
    const dialog = document.createElement('div');
    dialog.style.background = '#fff';
    dialog.style.borderRadius = '12px';
    dialog.style.boxShadow = '0 4px 32px rgba(0,0,0,0.25)';
    dialog.style.padding = '32px 24px';
    dialog.style.display = 'flex';
    dialog.style.flexDirection = 'column';
    dialog.style.alignItems = 'center';
    dialog.style.maxWidth = '90vw';
    dialog.style.minWidth = '320px';

    // Message
    const message = document.createElement('p');
    message.textContent = translatedMessage;
    message.style.fontSize = '1.1rem';
    message.style.color = '#222';
    message.style.marginBottom = '24px';
    message.style.textAlign = 'center';

    // Button container
    const buttonContainer = document.createElement('div');
    buttonContainer.style.display = 'flex';
    buttonContainer.style.flexDirection = 'row';
    buttonContainer.style.gap = '12px';
    buttonContainer.style.width = '100%';

    // Login Button
    const loginButton = document.createElement('button');
    loginButton.textContent = 'Opnieuw inloggen';
    loginButton.style.background = '#0078D7';
    loginButton.style.color = '#fff';
    loginButton.style.fontSize = '1rem';
    loginButton.style.padding = '12px 28px';
    loginButton.style.border = 'none';
    loginButton.style.borderRadius = '6px';
    loginButton.style.cursor = 'pointer';
    loginButton.style.width = '100%';
    loginButton.addEventListener('click', function() {
        var currentLocation = window.location.pathname + window.location.search + window.location.hash;
        var encoded = encodeURIComponent(currentLocation);
        window.location.href = `/mvc/account/login?returnurl=${encoded}`;
    });

    // Home Button
    const homeButton = document.createElement('button');
    homeButton.textContent = 'Ga naar homepagina';
    homeButton.style.background = '#e0e0e0';
    homeButton.style.color = '#222';
    homeButton.style.fontSize = '1rem';
    homeButton.style.padding = '12px 28px';
    homeButton.style.border = 'none';
    homeButton.style.borderRadius = '6px';
    homeButton.style.cursor = 'pointer';
    homeButton.style.width = '100%';
    homeButton.addEventListener('click', function() {
        window.location.href = '/';
    });

    // Add buttons to container
    buttonContainer.appendChild(loginButton);
    buttonContainer.appendChild(homeButton);

    // Compose dialog
    dialog.appendChild(message);
    dialog.appendChild(buttonContainer);

    // Add dialog to overlay
    overlay.appendChild(dialog);

    // Add overlay to body
    document.body.appendChild(overlay);

    // Optionally, prevent scrolling
    document.body.style.overflow = 'hidden';
  }

  static getCookie(cname) {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  static setCookie(name, value, days) {
    var expires = '';
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = ''; expires='' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '')  + expires + '; path=/';
  }

  static getRandomID (length = 7) {
    return Math.random().toString(36).substring(length);
  }
  static isEmail(email) {
    // eslint-disable-next-line
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
  }
  static getEmail(email) {
    // eslint-disable-next-line
    var regex = /([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})/;
    var result = email.match(regex);
    if (result && result[0]) return result[0];
    return null;
  }
  static getQueryParameters() {
    let keyPairs = [];
    let params = window.location.search.substring(1).split('&');
    for (var i = params.length - 1; i >= 0; i--) {
      keyPairs.push(params[i].split('='));
    }
    let result = {};
    for (let pair of keyPairs) {
      result[pair[0]] = pair[1];
    }
    return result;
  }
  static convertObjectToQueryString(uri, body) {
    if (body) {
      let searchquery = new URLSearchParams(body);
      if (searchquery) {
        uri += `?${searchquery.toString()}`;
      }
    }
    return uri;
  }


  /**
   * Case insensitive check if property exists on an Object
   * @param {object} obj
   * @param {string} stringKey
   */
  static objContains(obj, stringKey) {
    for (var prop in obj) {
      if (Utils.equals(prop, stringKey) === true) return true;
    }
    return false;
  }
  /**
   * Case insensitive to get an object property's value
   * @param {object} obj
   * @param {string} stringKey
   */
  static getProperty(obj, stringKey) {
    for (var prop in obj) {
      if (Utils.equals(prop, stringKey) === true) return obj[prop];
    }
    return null;
  }
  /**
   * Compare case insensitive
   * @param {string} string1
   * @param {string} string2
   */
  static equals(string1, string2) {
    var areEqual = string1.toUpperCase() === string2.toUpperCase();
    return areEqual;
  }

  static orderBy = (arr, props, orders) =>
  [...arr].sort((a, b) =>
    props.reduce((acc, prop, i) => {
      if (acc === 0) {
        const [p1, p2] = orders && orders[i] === 'desc' ? [b[prop], a[prop]] : [a[prop], b[prop]];
        acc = p1 > p2 ? 1 : p1 < p2 ? -1 : 0;
      }
      return acc;
    }, 0)
  );

  static scrollbarVisible(element) {
    return element.scrollHeight > element.clientHeight;
  }
  static isBarcode (value) {
    return (value !== null && value.length > 0 && value.startsWith("http://") || value.startsWith("https://"));
  }
  static stripBarcode (value) {
    if (value !== null && value.length > 0 && value.startsWith("http://") || value.startsWith("https://")) {
        value = value.substring(value.lastIndexOf('/') + 1);
    }
    return value;
  }

  /**
    * Returns true if the parameter is undefined/null or an empty string
  */
  static isNullOrWhitespace( input ) {
    if (typeof input === 'undefined' || input == null) return true;
    //Trim
    return input.replace(/\s/g, '').length < 1;
  }

  static printCertificate (blob, objectid, miplanid) {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${objectid} - ${miplanid}` + (blob.type === 'application/pdf' ? ".pdf" : "");
    link.click();
    URL.revokeObjectURL(link.href);
  }
  static async printDocument (data) {
    const header = data.response.headers.get('Content-Disposition');
    const parts = header.split(';');
    let filename = parts[1].split('=')[1];
    filename = filename.replaceAll('"', '');

    const link = document.createElement('a');
    link.href = URL.createObjectURL(await data.response.blob());
    link.download = filename;
    link.click();
    URL.revokeObjectURL(link.href);
  }

  static sanitizeUrl (url) {
    if (!url) return url;
    const invalidcharacters = ['<', '>', '*', '%', '&', ':', '\\'];
    invalidcharacters.forEach(char => {
      url = url.replace(char, '');
    });
    return url;
  }

  static getPageTitle(page, id, descr){
    const description = descr? " - " + descr : "";
    return page + " " + id + description;
  }

  static getFileExtension(fileName) {
    if (!fileName) {
      return "";
    }
    const lastDotIndex = fileName.lastIndexOf('.');
    if (lastDotIndex === -1 || lastDotIndex === 0) {
      return "";
    }
    return fileName.substring(lastDotIndex);
  }

  static getRouteParams(router, route) {
    if (!router || !route) {
      return null;
    }

    if (router.mode === 'hash') {
      return route.query;
    } else if (router.mode === 'abstract') {
      const uri = RouterUtils.parsePath(window.location.href);
      return RouterUtils.resolveQuery(uri.query);
    }
  }
}

export class Navigation{
  static navigate(url) {
    window.location.href = url;
  }
  static openInNewWindow(url){
    Navigation.openInNewTab(url);
  }
  static openInNewTab(url){
    // This works in IE 9, FF and Chrome.  Focusses the new tabwindow, unless you hold ctrl.
    window.open(url, '_blank');
      
    // Otherwise, if needed: fake a <a target=_blank> element to open in new tabpage. Focusses the new tab window, unless you hold ctrl.
    // Object.assign(document.createElement('a'), {
    //   target: '_blank',
    //   href: url
    // }).click();
  }
}

export const geturi = (relativeuri) => {
  let result = urljoin(config.getBase, relativeuri);
  return result;
};
